import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ICompanyObjectiveSettings } from 'src/app/modules/performance-objectives/models/CompanyObjectiveSettings';
import { ObjectiveService } from 'src/app/modules/performance-objectives/services/objective-service';

@Component({
  selector: 'app-style-guide-settings',
  templateUrl: './style-guide-settings.component.html',
  styleUrls: ['./style-guide-settings.component.scss']
})
export class StyleGuideSettingsComponent implements OnInit, OnDestroy {
  public saving = false;
  public settings: ICompanyObjectiveSettings;

  private _subscriptions: Subscription[] = [];

  constructor(
    private objectiveService: ObjectiveService,
  ) { }

  ngOnInit(): void {
    this._subscriptions.push(
      this.objectiveService.getSettings()
        .subscribe((settings: ICompanyObjectiveSettings) => {
          settings.linkCompetences = settings.developmentObjectivesLinkSkills > 0;
          this.settings = settings;
        }),
    );
  }

  linkCompetencesChanged() {

  }

  goalRightsChanged() {

  }

  saveSettings() {

  }

  ngOnDestroy(): void {
    for (const subscription of this._subscriptions) {
      subscription.unsubscribe();
    }
  }

}
